export enum ELoadingType {
  SPINNER = 'spinner',
  THREE_SQUARES = 'three-squares',
}
